import * as React from "react"

import { XBlockProps } from "react-xmasonry"

interface Props extends XBlockProps {
    bookmark: Models.Bookmark
    shouldShowWorkspaceScreenLabel: boolean
    onNavigate?: () => void
}

export default class BookmarkWidget extends React.Component<Props> {
    static defaultProps: Partial<Props> = {
        shouldShowWorkspaceScreenLabel: true,
    }

    render(): JSX.Element {
        const {
            bookmark: {
                bookmarkUrl,
                resourceType,
                title,
                icon,
                workspaceScreenLabel,
            },
            shouldShowWorkspaceScreenLabel,
            onNavigate,
        } = this.props

        return (
            <a
                className="theme-widget tw-mx-2 tw-mb-4 bg-cloud"
                data-ft-bookmark={title.toLowerCase()}
                data-ft-type={resourceType}
                href={bookmarkUrl}
                onClick={(): void => {
                    if (!!onNavigate) {
                        onNavigate()
                    }
                }}
            >
                <h3>{icon}</h3>
                <div className="label tw-mt-2" data-ft-component="title">
                    {title}
                </div>

                {shouldShowWorkspaceScreenLabel && !!workspaceScreenLabel && (
                    <div
                        className="text-nickel label is-dimmed"
                        data-ft-component="workspace"
                    >
                        {workspaceScreenLabel}
                    </div>
                )}
            </a>
        )
    }
}
